import React, { useEffect, useState } from 'react';
import client from '../../../../utils/prismicHelpers';
import * as queries from "../../../../utils/prismicQueries";
import HealthCard from '../../../health/HealthCard';
import './photogallery.css'
import GalleryImg from './GalleryImg';


const PhotoGallery = () => {
    const [galleryInfo, setGalleryInfo] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.photoGallery,
            })
            .then((response) => {
                const galleryDoc = response.data.allPhoto_gallerys.edges[0].node;
                setGalleryInfo(galleryDoc);


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <div>
            <h3 className="subtitle ">{galleryInfo?.title}</h3>
            <div className="row g-2" >
                {galleryInfo?.gallery_photo?.map((galleryPhoto, index) => <GalleryImg key={index + 1} cardInfo={galleryPhoto} />)}
            </div>


        </div>
    );
};

export default PhotoGallery;